import PropTypes from 'prop-types';
import {Form, Input} from 'antd';
import {connect} from 'react-redux';
import {SystemSelectNames} from '../SystemSelectEntityEnum';
import {RQCommonListData} from '@app/reactQuery/apis';
import {selectAuth} from '@app/redux/selectors';
import {isArray} from 'lodash';
import {useEffect, useRef} from 'react';

const SingleTextDependentObjectAttribute = ({auth, attributeMetadata, formValues, updateDynamicFieldValue}) => {
  const form = Form.useFormInstance();

  console.log(attributeMetadata);
  console.log(formValues);
  console.log(updateDynamicFieldValue);

  const parentValue = formValues[attributeMetadata?.input_parent_id];
  const selectEnum = SystemSelectNames[attributeMetadata?.select_entity];

  const updatedMisc = {...selectEnum.misc};
  Object.keys(updatedMisc).forEach(key => {
    const value = updatedMisc[key];
    if (value.startsWith('#') && value.endsWith('#')) {
      updatedMisc[key] = parentValue;
    }
  });

  const {data} = RQCommonListData(
    {
      misc: updatedMisc,
      name: selectEnum?.name,
      api: selectEnum?.api,
      certificate: auth?.certificate,
      userId: auth?.principal?.id,
      locationId: auth?.user?.location?.id,
      filter: {
        ...selectEnum?.filter,
      },
    },
    {
      enabled: !!parentValue,
    },
  );

  const dependentData = isArray(data) ? data[0] : data;
  const fieldValue = dependentData ? dependentData[attributeMetadata?.display_field] : '';

  const manualEditRef = useRef(false);
  const lastParentRef = useRef(undefined);
  const lastAppliedFieldValueRef = useRef(undefined);

  useEffect(() => {
    if (fieldValue === undefined) {
      return;
    }

    const currentValue = form.getFieldValue(attributeMetadata.id);

    if (lastParentRef.current === undefined) {
      lastParentRef.current = parentValue;
      if ((currentValue === undefined || currentValue === '' || currentValue === null) && !manualEditRef.current) {
        if (currentValue !== fieldValue) {
          form.setFieldValue(attributeMetadata.id, fieldValue);
          updateDynamicFieldValue?.({[attributeMetadata.id]: fieldValue});
          lastAppliedFieldValueRef.current = fieldValue;
        }
      }
      return;
    }

    if (lastParentRef.current !== parentValue) {
      lastParentRef.current = parentValue;

      manualEditRef.current = false;

      if (!manualEditRef.current && fieldValue !== undefined && currentValue !== fieldValue) {
        form.setFieldValue(attributeMetadata.id, fieldValue);
        updateDynamicFieldValue?.({[attributeMetadata.id]: fieldValue});
        lastAppliedFieldValueRef.current = fieldValue;
      }
      return;
    }

    if (!manualEditRef.current && currentValue !== fieldValue) {
      form.setFieldValue(attributeMetadata.id, fieldValue);
      updateDynamicFieldValue?.({[attributeMetadata.id]: fieldValue});
      lastAppliedFieldValueRef.current = fieldValue;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldValue, parentValue]);

  const handleChange = e => {
    const newValue = e?.target?.value;
    manualEditRef.current = true;
    updateDynamicFieldValue?.({[attributeMetadata.id]: newValue});
  };

  const isVertical = attributeMetadata?.layout === 'vertical';

  return (
    <Form.Item
      name={attributeMetadata.id}
      label={attributeMetadata.label}
      rules={attributeMetadata.validation_rules}
      wrapperCol={{
        span: isVertical
          ? (attributeMetadata?.vertical_value_col_span || 24)
          : 20,
      }}
      labelCol={{
        span: isVertical ? 24 : 4,
        ...((isVertical && attributeMetadata?.vertical_label_height)
          ? {style: {height: attributeMetadata?.vertical_label_height}}
          : {}),
      }}
    >
      <Input
        placeholder={attributeMetadata?.placeholder}
        disabled={attributeMetadata?.editable === false}
        onChange={handleChange}
      />
    </Form.Item>
  );
};

SingleTextDependentObjectAttribute.propTypes = {
  auth: PropTypes.shape({
    certificate: PropTypes.string.isRequired,
    principal: PropTypes.any,
    user: PropTypes.any,
  }).isRequired,
  attributeMetadata: PropTypes.shape({
    id: PropTypes.string.isRequired,
    editable: PropTypes.bool,
    validation_rules: PropTypes.array,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    select_entity: PropTypes.string.isRequired,
    input_parent_id: PropTypes.string.isRequired,
    display_field: PropTypes.string.isRequired,
    layout: PropTypes.string,
    vertical_value_col_span: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vertical_label_height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  formValues: PropTypes.object.isRequired,
  updateDynamicFieldValue: PropTypes.func,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState)(SingleTextDependentObjectAttribute);
